import React from 'react';

import PropTypes from 'prop-types';

import AppWrapper from 'components/apps/AppWrapper';
import NoUserPermissionsSetBanner from 'components/users/NoUserPermissionsSetBanner';

export default function NoUserPermissionsSetBannerWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <NoUserPermissionsSetBanner {...wrappedProps} />
    </AppWrapper>
  );
}

NoUserPermissionsSetBannerWrapper.propTypes = {
  wrappedProps: PropTypes.shape({
    divisionName: PropTypes.string.isRequired,
  }),
};
